import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { RESEND_MESSAGE_URL } from 'api/SentMessagesAPI';
import { RestMutateHookResult, useRestMutation } from 'utils/hooks/api/useRestMutation';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';

export const useResendMessageMutation = (
  userId: string,
): [
  resend: (messageId: string, messageMedium: string) => void,
  result: Omit<RestMutateHookResult<unknown, unknown>, 'mutate'>,
] => {
  const dispatch = useDispatch();
  const { mutate, ...result } = useRestMutation(RESEND_MESSAGE_URL);
  const resendMessage = (messageId: string, messageMedium: string) =>
    mutate({ messageId, messageMedium, recipient: userId });

  const displayText = {
    error: `Could not resend message to ${userId}. Please try again.`,
    success: `Message resent to ${userId}.`,
  };

  // Show toasts in response to API hook state changes
  useEffect(() => {
    if (result.isLoading || !result.data) return;
    if (result.isError) {
      dispatch(addNegativeToast(displayText.error));
    } else if (result.isSuccess) {
      dispatch(addPositiveToast(displayText.success));
    }
  }, [result.data, result.isError, result.isLoading]);

  return [resendMessage, result];
};
